import { trackEvent } from '@nile/mantine-theme/analytics'

interface Track500Params {
    endpoint: string
    method: string
    status: number
    errorData?: unknown
}

export function track500Error({ endpoint, method, status, errorData }: Track500Params) {
    try {
        const errorMessage = typeof errorData === 'object' && (errorData as any)?.message
            ? (errorData as any).message
            : typeof errorData === 'object' && (errorData as any)?.error
            ? (errorData as any).error
            : null

        trackEvent('api_500_error', {
            endpoint,
            method: method?.toUpperCase?.() ?? 'UNKNOWN',
            status,
            page: typeof window !== 'undefined' ? window.location.pathname : 'unknown',
            errorMessage,
        })
    } catch {
        // Silently fail - don't let error tracking cause user-facing errors
    }
}
